/* Recover this working design after a tab/process restart. A random URL token
   scopes the durable backup; clean visits and saved links stay independent.
   Never replay old prices or store image pixels. */
(function () {
  'use strict';
  var node=document.getElementById('myx-design-inspiration-config');
  if(!node||window.__MAYTRIX_SAVED_VIEWER_EMBED__)return;
  var root=document.documentElement,config=JSON.parse(node.textContent),params=new URLSearchParams(location.search);
  var key='maytrix:working-design:v1:'+location.pathname,api=null,restoring=false,edited=false,last='',timer=0,attempts=0,draft=null,cancelled=false;
  function address(){return location.pathname+location.search;}
  function copy(value){return JSON.parse(JSON.stringify(value));}
  function durable(value){return typeof value==='string'&&!/^(blob:|data:)/i.test(value);}
  function recoveringVisit(){
    // sessionStorage survives leaving this page, and can be copied into a new
    // tab. Only a reload/history return should resume an unfinished design.
    var type=performance.getEntriesByType?.('navigation')?.[0]?.type;
    if(type)return type==='reload'||type==='back_forward';
    return performance.navigation?.type===1||performance.navigation?.type===2;
  }
  var backupPrefix='maytrix:working-design:v2:', draftToken=params.get('myxdraft')||'';
  if(!/^[a-z0-9-]{24,64}$/i.test(draftToken))draftToken='';
  function read(storage,key){try{return JSON.parse(storage.getItem(key)||'null');}catch(_){return null;}}
  function valid(record){return record&&(record.version===1||record.version===2)&&
    Date.now()-record.at<8*60*60*1000&&record.url===address()&&Array.isArray(record.layers);}
  function discard(){
    try{sessionStorage.removeItem(key);}catch(_){}
    if(draftToken)try{localStorage.removeItem(backupPrefix+draftToken);}catch(_){}
  }
  {
    // Safari may recover a killed web process as a navigation, with the tab's
    // session storage missing. The URL identifies only this customer's draft.
    if(draftToken){
      try{draft=read(localStorage,backupPrefix+draftToken);}catch(_){}
      if(valid(draft))root.dataset.myxDraftRecoverySource='device';else draft=null;
    }
    if(!draft&&(draftToken||recoveringVisit())){
      try{draft=read(sessionStorage,key);}catch(_){}
      if(valid(draft))root.dataset.myxDraftRecoverySource='tab';else draft=null;
    }
  }
  if(!draft)try{sessionStorage.removeItem(key);}catch(_){}
  function write(record){
    var destination=address(),token=draftToken;
    if(!token){
      try{token=crypto.randomUUID();}catch(_){token='';}
    }
    var nextUrl=new URL(location.href);
    if(token)nextUrl.searchParams.set('myxdraft',token);
    var durableUrl=nextUrl.pathname+nextUrl.search;
    var stored=false;
    if(token){
      try{
        localStorage.setItem(backupPrefix+token,JSON.stringify(Object.assign({},record,{url:durableUrl})));
        // Only alter this tab's address after the backup is safely written.
        if(durableUrl!==destination)history.replaceState(history.state,'',nextUrl.href);
        destination=durableUrl;draftToken=token;stored=true;
        // Bound local storage even if customers open many independent designs.
        var records=[];
        for(var i=0;i<localStorage.length;i++){
          var name=localStorage.key(i);if(!name||name.indexOf(backupPrefix)!==0)continue;
          var item=read(localStorage,name);
          if(!item||Date.now()-item.at>=8*60*60*1000)localStorage.removeItem(name);
          else records.push({key:name,at:item.at});
        }
        records.sort(function(a,b){return b.at-a.at;}).slice(4).forEach(function(item){localStorage.removeItem(item.key);});
      }catch(_){}
    }
    record.url=destination;
    try{sessionStorage.setItem(key,JSON.stringify(record));stored=true;}catch(_){}
    return stored;
  }
  if(draft){window.__MAYTRIX_DRAFT_RESTORE_PENDING__=true;root.dataset.myxDraftRecovery='pending';}
  function save(beforeEdit){
    if(root.dataset.myxDefaultApplying==='true'||root.dataset.myxTemplateApplying==='true'||!api||restoring||!edited||(!beforeEdit&&root.dataset.myxInspiration==='cycling')||root.classList.contains('myx-inspiration-fading'))return;
    try{
      var state=api.State,viewer=window.__MAYTRIX_VIEWER__?.getState();
      if(!state.Product?.layers?.length||!viewer)return;
      // A local file is transient until CPB finishes uploading it. Retain the
      // previous complete draft while that upload is pending.
      if(viewer.logoImageUrl&&!durable(viewer.logoImageUrl))return;
      var layers=state.Product.layers.filter(function(l){return l.panel!=='base';}).map(function(l){
        var out={panel:l.panel,category:l.category,option:l.option,value:l.value};
        if(l.fileUploadData)out.fileUploadData={name:l.fileUploadData.name,type:l.fileUploadData.type};
        return out;
      });
      var record={version:2,url:address(),layers:layers,viewer:viewer,logoMemory:window.__MAYTRIX_LOGO_MEMORY__?.draft?.()||null,view:state.App.settings.currentView,scene:window.__MYX_SCENES__?.getPreferred?.()||root.dataset.myxRoomView||'club'};
      var body=JSON.stringify(record);
      if(body.length>180000||/"(?:blob:|data:image\/)/i.test(body))return;
      if(body===last)return;
      record.at=Date.now();
      if(!write(record))throw Error('Storage unavailable');
      last=JSON.stringify(Object.assign({},record,{at:undefined}));
      root.dataset.myxDraftRecovery='saved';
    }catch(_){root.dataset.myxDraftRecovery='unavailable';}
  }
  function queue(){if(!edited)return;clearTimeout(timer);timer=setTimeout(save,500);}
  function release(status){
    restoring=false;window.__MAYTRIX_DRAFT_RESTORE_PENDING__=false;root.dataset.myxDraftRecovery=status;
    if(status==='restored'||status==='cancelled'){
      window.__MAYTRIX_DRAFT_RESTORED__=true;
      // The Levels fallback belongs only to the showcase. Restored prices and
      // dimensions must come from CPB's current calculation.
      root.classList.remove('myx-initial-price-pending');
    }
  }
  async function restore(){
    restoring=true;
    try{
      var state=api.State,panels=state.Product.panels;
      // Use today's product/options and pricing. A removed option invalidates
      // this old tab draft instead of creating an inconsistent cart.
      if(!draft.layers.every(function(l){return panels.some(function(p){return p.id===l.panel&&p.categories.some(function(c){return c.id===l.category&&c.options.some(function(o){return o.id===l.option;});});});}))throw Error('Options changed');
      var layers=copy(draft.layers);layers.view=draft.view||state.App.settings.currentView;
      layers.forEach(function(l){
        if(!l.fileUploadData||!durable(l.value))return;
        var p=panels.find(function(p){return p.id===l.panel;}),c=p.categories.find(function(c){return c.id===l.category;}),o=c.options.find(function(o){return o.id===l.option;});
        o.fileUploadValue=l.value;o.fileNameValue=l.fileUploadData.name;o.fileTypeValue=l.fileUploadData.type;o.beforeRemoveBg=null;o.imageWithMockup=null;
      });
      var descriptor=Object.getOwnPropertyDescriptor(window,'layer');
      try{
        if(!descriptor)Object.defineProperty(window,'layer',{value:null,writable:true,configurable:true});
        api.dispatch({type:'Product/productLayersFromConfigUpdate',payload:{data:layers,globalState:state}});
      }finally{if(descriptor)Object.defineProperty(window,'layer',descriptor);else delete window.layer;}
      var viewer=window.__MAYTRIX_VIEWER__,current=viewer.getState(),patch={};
      Object.keys(draft.viewer||{}).forEach(function(k){if(Object.prototype.hasOwnProperty.call(current,k)&&typeof current[k]!=='function')patch[k]=draft.viewer[k];});
      viewer.setState(patch);
      window.__MAYTRIX_LOGO_MEMORY__?.restoreDraft?.(draft.logoMemory);
      document.body.dispatchEvent(new CustomEvent('CPB_ON_OPTIONS_UPDATE'));
      await new Promise(function(resolve){setTimeout(resolve,400);});
      if(!cancelled){viewer.setState(patch);if(draft.scene)window.__MYX_SCENES__?.select?.(draft.scene);}
      edited=true;release('restored');queue();
    }catch(error){release('unavailable');discard();console.warn('[Maytrix draft] Could not restore this tab:',error.message);}
  }
  async function init(){
    if(++attempts>400){release('unavailable');return;}
    if(!window.CPB?.createFrontApi||!window.__MAYTRIX_VIEWER__?.getState||!root.classList.contains('myx-alt-controls-ready')){setTimeout(init,150);return;}
    try{api=await window.CPB.createFrontApi(config.frontApiKey);if(!api.getAuthStatus().isAuthorized)throw Error('API unavailable');if(draft&&!cancelled)await restore();else if(cancelled)release('cancelled');}
    catch(_){release('unavailable');return;}
    // CPB can finish an upload after its input event; this bounded lightweight
    // snapshot also catches adjustments made through custom controls.
    setInterval(save,2000);
  }
  ['input','change','click','keydown'].forEach(function(type){document.addEventListener(type,function(event){
    var type=event.type;
    if(!event.isTrusted||!event.target?.closest?.('#product-builder,#myx-design-review,#myx-example-gallery'))return;
    var target=event.target;
    if(type==='keydown'){if(event.repeat||!['Enter',' '].includes(event.key)||target.closest('input,textarea,select'))return;type='click';}
    var galleryChoice=target.closest('#myx-example-gallery [data-myx-gallery-option]');
    if(type==='click'&&galleryChoice){
      if(galleryChoice.getAttribute('aria-pressed')==='true')return;
      edited=true;if(draft)cancelled=true;save(true);queue();return;
    }
    if(target.closest('.myx-room-picker,.preview-tools,.myx-builder-power,[data-myx-customizer-step],.cpb-example-button,[data-myx-example-for],[data-myx-template-open],summary,[aria-expanded],.cpb-next-tab-button'))return;
    if(type==='click'){
      // Focusing, browsing tabs, and opening scenes are not saved designs.
      if(target.closest('input,textarea,select'))return;
      var choice=target.closest('.cpb-option[data-option-id],[data-myx-mount],.myx-size-card,.myx-size-choice,[data-myx-size],[data-myx-star-option],[data-myx-star-color],[data-myx-star-background-color],[data-myx-font-name]');
      if(choice&&(choice.hasAttribute('aria-pressed')?choice.getAttribute('aria-pressed')==='true':choice.classList.contains('cpb-active')))return;
      if(!choice&&!target.closest('.cpb-panels-container button,.cpb-panels-container [role="button"],.cpb-panels-container [role="checkbox"]'))return;
    }else if(!target.closest('input,textarea,select,[contenteditable="true"]'))return;
    edited=true;if(draft)cancelled=true;save(true);queue();
  },true);});
  window.addEventListener('maytrix:template-applied',function(){edited=true;if(draft)cancelled=true;queue();});
  window.addEventListener('maytrix:default-design-applied',function(){edited=true;cancelled=true;draft=null;discard();last='';queue();});
  document.body.addEventListener('CPB_ON_OPTIONS_UPDATE',queue);
  window.addEventListener('pagehide',function(){save();});
  window.addEventListener('maytrix:preview-context-lost',function(){save();});
  document.addEventListener('visibilitychange',function(){if(document.hidden)save();});
  init();
})();

(function () {
  'use strict';
  var params = new URLSearchParams(location.search);
  if (params.has('configid') || params.has('myxv') || params.has('myxr') || params.has('view') || window.__MAYTRIX_SAVED_VIEWER_EMBED__) return;
  var node = document.getElementById('myx-design-inspiration-config');
  if (!node) return;
  var config = JSON.parse(node.textContent), api = null, originalLayers = null;
  // Native background removal forwards this URL to a server, which needs a scheme.
  config.presets.concat(config.templates||[]).forEach(function(preset) {
    if (typeof preset.logo === 'string' && preset.logo.slice(0, 2) === '//') preset.logo = 'https:' + preset.logo;
  });
  var stopped = false, epoch = 0, index = -1, timer = 0, initTimer = 0, started = false, busy = false, stopPaintTimer = 0, stopReason = '', pendingNext = null, pendingTurnAngle = null, pagePaused = false;
  var images = new Map(), sequence = config.presets.filter(function(p){return p.id!=='low-key-cocktail-bar';}).concat(config.templates||[]), hasShown=false;
  var watchTimer=0, watchAt=0, watchActive=false, visibleStallMs=0, initAt=0, initVisibleMs=0;
  var root = document.documentElement;
  function prepareShowcase(){
    root.dataset.myxInspirationAuto='true';root.classList.add('myx-inspiration-starting');
    // Failed draft recovery can finish after the camera mounted with motion
    // paused. Start that existing camera as well as a newly mounted one.
    window.dispatchEvent(new CustomEvent('maytrix:inspiration-play'));
    if(root.dataset.myxPreviewSway==='paused')root.dataset.myxPreviewSway='running';
  }
  if(!window.__MAYTRIX_DRAFT_RESTORE_PENDING__&&root.dataset.myxTemplateApplying!=='true')prepareShowcase();
  // The viewer fades the product against its room render; the canvas stays visible.
  function clone(value){return JSON.parse(JSON.stringify(value));}
  // Use the exact same configuration as the selectable gallery templates.
  function makeLayers(preset,state){return window.__MYX_TEMPLATE_MODEL__.makeLayers(preset,state,originalLayers);}
  function syncUploadMetadata(state,preset){return window.__MYX_TEMPLATE_MODEL__.syncUploadMetadata(state,preset);}
  function viewerState(preset){return window.__MYX_TEMPLATE_MODEL__.viewerState(preset);}
  function preload(preset) {
    if(!preset.logo)return Promise.resolve();
    if(!images.has(preset.logo))images.set(preset.logo,new Promise(function(resolve,reject){var image=new Image();image.decoding='async';image.onload=function(){resolve(image);};image.onerror=reject;image.src=preset.logo;}));
    return images.get(preset.logo);
  }
  function reveal(){root.classList.remove('myx-initial-price-pending','myx-inspiration-starting','myx-inspiration-fading');root.dataset.myxInspirationTransition='visible';}
  function delay(ms){return new Promise(function(resolve){setTimeout(resolve,ms);});}
  function frames(){return new Promise(function(resolve){requestAnimationFrame(function(){requestAnimationFrame(resolve);});});}
  function clock(){return performance.now();}
  async function waitForFadeHidden(token){
    var begin=clock();
    while(!stopped&&token===epoch){
      await frames();
      var canvas=document.querySelector('#viewer-3d-root canvas');
      if(canvas&&Number(canvas.dataset.mirrorFade)<=.001)return;
      if(clock()-begin>2500)throw new Error('Preview fade did not finish');
    }
  }
  async function waitForPresetReady(patch,token){
    var begin=clock(),stable=0;
    while(!stopped&&token===epoch){
      await frames();
      var current=window.__MAYTRIX_VIEWER__?.getState?.(),motion=window.MaytrixModelMotion;
      var mismatches=current?Object.keys(patch).filter(function(key){return key!=='logoAssetRevision'&&JSON.stringify(current[key])!==JSON.stringify(patch[key]);}):['viewer'];
      var matches=mismatches.length===0;
      var artworkReady=!patch.logoImageUrl||Array.from(motion?.readyLogoUrls||[]).some(function(source){return source===patch.logoImageUrl||source.indexOf(patch.logoImageUrl+(patch.logoImageUrl.indexOf('?')>=0?'&':'?')+'rev=')===0;});
      root.dataset.myxInspirationReady=JSON.stringify({matches:mismatches,artwork:artworkReady,pending:motion?.textures||0});
      if(matches&&artworkReady&&motion&&motion.textures===0){
        if(!stable)stable=clock();
        if(clock()-stable>=120)return;
      }else stable=0;
      if(clock()-begin>6000)throw new Error('Preview artwork did not finish loading');
    }
  }
  function previewIsVisible(){
    var canvas=document.querySelector('#viewer-3d-root canvas');if(!canvas)return false;
    var rect=canvas.getBoundingClientRect();
    return rect.width>0&&rect.height>0&&rect.bottom>0&&rect.top<window.innerHeight&&rect.right>0&&rect.left<window.innerWidth;
  }
  function watchCycle(){
    if(stopped)return;
    var now=clock(),active=!busy&&!document.hidden&&!pagePaused&&index>=0&&root.dataset.myxInspirationTransition==='visible'&&root.dataset.myxPreviewSway==='running'&&previewIsVisible();
    // iOS may suspend rendering without delivering the one-shot turn event.
    // Count only successive visible ticks; sleep, hidden tabs and off-screen
    // previews never exhaust the grace period or rush the normal turn cadence.
    if(active&&watchActive)visibleStallMs+=Math.min(1000,Math.max(0,now-watchAt));
    watchAt=now;watchActive=active;
    if(active&&visibleStallMs>=16000){
      visibleStallMs=0;root.dataset.myxInspirationRecovery='sway-watchdog';
      var angle=Number(window.__MAYTRIX_ORBIT__?.getView?.()?.theta);
      pendingTurnAngle=Number.isFinite(angle)&&Math.abs(angle)>.01&&Math.abs(angle)<Math.PI/2?angle:null;
      pendingNext=(index+1)%sequence.length;schedule();
    }
    watchTimer=setTimeout(watchCycle,1000);
  }
  function paintStop(){reveal();root.dataset.myxInspiration='stopped';root.dataset.myxInspirationStop=stopReason;}
  function stop(reason,deferPaint){
    if(stopped)return;stopped=true;pendingNext=null;pendingTurnAngle=null;epoch++;clearTimeout(timer);clearTimeout(initTimer);clearTimeout(watchTimer);stopReason=reason;
    // Cancel pending preset writes immediately, but let the customer's current
    // event finish before painting so its option DOM stays stable.
    if(deferPaint)stopPaintTimer=setTimeout(paintStop,0);else paintStop();
  }
  function interaction(event){
    if(!event.isTrusted)return;
    if(stopped){if(/^(click|change|input)$/.test(event.type)){clearTimeout(stopPaintTimer);stopPaintTimer=setTimeout(paintStop,0);}return;}
    var target=event.target instanceof Element?event.target:null;if(!target)return;
    if(event.type==='input'||event.type==='change'){
      if(target.closest('#product-builder input,#product-builder textarea,#product-builder select')&&!target.closest('[data-action="offset-value"]'))stop('edit',true);
      return;
    }
    if(event.type==='keydown'&&(event.repeat||!['Enter',' '].includes(event.key)))return;
    if(event.type!=='click'&&event.type!=='keydown')return;
    var galleryChoice=target.closest('#myx-example-gallery [data-myx-gallery-option]');
    if(galleryChoice){if(galleryChoice.getAttribute('aria-pressed')!=='true')stop('edit',true);return;}
    // Scene browsing and the light switch preserve both motion and the showcase.
    if(target.closest('.myx-room-picker,.preview-tools,.myx-builder-power'))return;
    // Browsing is not editing: touch-down can become a scroll or cancelled tap,
    // and focusing a field or opening a disclosure does not change the design.
    if(target.closest('input,textarea,select,summary,[aria-expanded],[data-myx-customizer-step],[data-myx-example-for],[data-myx-template-open],.cpb-example-button,[data-action="offset-value"],.cpb-next-tab-button'))return;
    var choice=target.closest('#product-builder .cpb-option[data-option-id],#product-builder [data-myx-mount],#product-builder [data-myx-star-option],#product-builder .myx-size-card,#product-builder .myx-size-choice,#product-builder [data-myx-size],#product-builder [data-myx-star-color],#product-builder [data-myx-star-background-color],#product-builder [data-myx-font-name]');
    // These are single-choice controls. Selecting the current value is a no-op.
    if(choice&&(choice.hasAttribute('aria-pressed')?choice.getAttribute('aria-pressed')==='true':choice.classList.contains('cpb-active')))return;
    if(choice||target.closest('#product-builder [role="checkbox"],#product-builder .cpb-panels-container button,#product-builder .cpb-panels-container [role="button"]'))stop('edit',true);
    else if(target.closest('#product-builder .cpb-product-actions button,#product-builder .myx-customizer-actions-shell button,#myx-design-review,[data-myx-review-trigger],.myx-review-save-proxy'))stop('action',true);
  }
  window.addEventListener('maytrix:design-start',function(){stop('start-designing',true);});
  ['input','change','click','keydown'].forEach(function(type){document.addEventListener(type,interaction,true);});
  function schedule(){
    clearTimeout(timer);
    // Active sway advances the showcase at every left/right turn. After manual
    // camera use stops sway, continue cycling on the timed fallback.
    if(stopped||busy||document.hidden||pagePaused)return;
    // A tab can disappear between the one-shot sway event and the hidden swap.
    // Retain that requested design so returning cannot strand the current one.
    if(pendingNext!==null)timer=setTimeout(function(){return switchTo(pendingNext);},0);
    else if(root.dataset.myxPreviewSway!=='running')timer=setTimeout(function(){return switchTo((index+1)%sequence.length);},8000);
  }
  window.addEventListener('maytrix:inspiration-sway-complete',function(event){
    if(stopped)return;visibleStallMs=0;
    var angle=Number(event.detail&&event.detail.turnAngle);
    pendingTurnAngle=Number.isFinite(angle)&&Math.abs(angle)>.01&&Math.abs(angle)<Math.PI/2?angle:null;
    pendingNext=(index+1)%sequence.length;schedule();
  });
  window.addEventListener('maytrix:template-start',function(){stop('template');});
  // Camera gestures change the view, not the customer’s design. Keep the
  // showcase alive when the viewer hands camera control to the customer.
  window.addEventListener('maytrix:preview-sway-stopped',function(){schedule();});
  async function switchTo(next){
    if(document.body.classList.contains('myx-review-open')){stop('review');return;}
    if(stopped||busy)return;pendingNext=next;if(document.hidden||pagePaused)return;busy=true;var token=epoch,preset=sequence[next],turnAngle=pendingTurnAngle;
    try{
      await preload(preset);
      if(document.body.classList.contains('myx-review-open')){stop('review');return;}
      if(stopped||token!==epoch||document.hidden||pagePaused)return;
      if(index>=0){
        root.dataset.myxInspirationTransition='fading-out';
        root.classList.add('myx-inspiration-fading');
        await waitForFadeHidden(token);
        if(stopped||token!==epoch||document.hidden||pagePaused)return;
      }
      root.dataset.myxInspirationTransition='swapping';
      var state=api.State,layers=makeLayers(preset,state),viewer=window.__MAYTRIX_VIEWER__,patch=viewerState(preset);
      syncUploadMetadata(state,preset);
      // The existing configuration reducer recalculates the real option logic and price in one dispatch.
      // CPB 4.20.0's restore reducer assigns an undeclared `layer` in strict mode.
      // Supply a synchronous compatibility slot, then restore the global exactly.
      var layerDescriptor=Object.getOwnPropertyDescriptor(window,'layer');
      try {
        if(!layerDescriptor)Object.defineProperty(window,'layer',{value:null,writable:true,configurable:true});
        api.dispatch({type:'Product/productLayersFromConfigUpdate',payload:{data:layers,globalState:state}});
      } finally {
        if(layerDescriptor)Object.defineProperty(window,'layer',layerDescriptor);else delete window.layer;
      }
      viewer.setState(patch);index=next;pendingNext=null;pendingTurnAngle=null;visibleStallMs=0;watchActive=false;
      root.dataset.myxInspiration='cycling';root.dataset.myxInspirationPreset=preset.id;
      window.dispatchEvent(new CustomEvent('maytrix:inspiration-preset',{detail:{id:preset.id,initial:!hasShown,turnAngle:turnAngle}}));
      // Keep the shape/texture/CPB bridge updates covered by the fade. A real edit
      // cancels every remaining preset write, including this delayed refresh.
      await frames();
      if(stopped||token!==epoch)return;
      viewer.setState(patch);document.body.dispatchEvent(new CustomEvent('CPB_ON_OPTIONS_UPDATE'));
      await delay(320);
      if(stopped||token!==epoch)return;
      // The preset reducer and its price have rendered before revealing the first
      // example. Do not hold the animation behind an unrelated pricing worker.
      viewer.setState(patch);
      await waitForPresetReady(patch,token);
      if(stopped||token!==epoch)return;
      if(!hasShown)root.dataset.myxInspirationFirstReady='true';
      reveal();root.dataset.myxInspirationTransition='fading-in';
      await delay(320);
      if(stopped||token!==epoch)return;
      root.dataset.myxInspirationTransition='visible';
      window.dispatchEvent(new CustomEvent('maytrix:inspiration-visible',{detail:{initial:next===0&&index===0&&!hasShown}}));
      hasShown=true;
      preload(sequence[(next+1)%sequence.length]).catch(function(){});
    }catch(error){root.dataset.myxInspirationError=String(error.message||'Example unavailable');stop('unavailable');console.warn('[Maytrix examples]',error);}
    finally{busy=false;if(!stopped){reveal();schedule();}}
  }
  async function init(){
    if(stopped||started)return;
    if(root.dataset.myxDesignStarted==='true'){stop('start-designing');return;}
    if(root.dataset.myxTemplateApplying==='true'||root.dataset.myxTemplateSelected){stop('template');return;}
    var now=clock();
    if(document.hidden||pagePaused){initAt=now;initTimer=setTimeout(init,500);return;}
    if(initAt) initVisibleMs+=Math.min(1000,Math.max(0,now-initAt));
    initAt=now;
    // Slower phones and backgrounded launches need a readiness budget based on
    // actual foreground waiting, not 20 seconds elapsed since the request began.
    if(initVisibleMs>60000){stop('not-ready');return;}
    if(window.__MAYTRIX_DRAFT_RESTORE_PENDING__){initTimer=setTimeout(init,150);return;}
    if(window.__MAYTRIX_DRAFT_RESTORED__){stop('restored-design');return;}
    // An expired/invalid draft or failed recovery must fall back to the normal
    // first example, rather than leaving the native default frozen on screen.
    if(root.dataset.myxInspirationAuto!=='true')prepareShowcase();
    if(!window.CPB?.createFrontApi||!window.__MAYTRIX_VIEWER__?.getState||!root.classList.contains('myx-alt-controls-ready')){initTimer=setTimeout(init,150);return;}
    if(window.__MAYTRIX_SAVED_CONFIG_RESTORE_PENDING__||document.body.classList.contains('myx-review-open')){stop('saved-design');return;}
    started=true;watchAt=clock();watchCycle();
    try{api=await window.CPB.createFrontApi(config.frontApiKey);if(stopped)return;if(!api.getAuthStatus().isAuthorized)throw new Error('Examples API unavailable');originalLayers=clone(api.State.Product.layers);await switchTo(0);}catch(e){root.dataset.myxInspirationError=String(e.message||e);stop('not-ready');}
  }
  document.addEventListener('visibilitychange',function(){clearTimeout(timer);watchActive=false;watchAt=clock();initAt=clock();if(!document.hidden&&!stopped){if(index<0&&api)switchTo(0);else if(!started){clearTimeout(initTimer);init();}else schedule();}});

  window.addEventListener('pagehide',function(event){
    if(event.persisted){pagePaused=true;watchActive=false;initAt=clock();clearTimeout(timer);}else stop('leave');
  });
  window.addEventListener('pageshow',function(event){if(event.persisted){pagePaused=false;watchActive=false;watchAt=clock();initAt=clock();if(!stopped){if(index<0&&api)switchTo(0);else if(!started){clearTimeout(initTimer);init();}else schedule();}}});
  window.addEventListener('popstate',function(){stop('navigation');});
  preload(sequence[0]).catch(function(){});init();
})();
